<template>
  <section>
    <div class="flex items-center justify-between mb-4">
      <h4 class="mb-2">
        {{ $t("stats.course.sidebar.attentionLogs") }}
      </h4>
      <Button
        :label="$t('labels.generic', { pt: 'Baixar', en: 'Download' })"
        icon="pi pi-download"
        class="p-button-sm btn-primary h-9"
        :loading="btnLoading"
        @click="downloadCSV"
      />
    </div>
    <div class="bg-white rounded-lg border border-gray-300">
      <Table
        :slotData="items"
        :columns="columns"
        :actions="actions"
        :loading="loading"
        :filters="filters"
        :params="params"
        :hasStatus="true"
        :hasActions="false"
        :actionsTitle="$t('labels.generic', { pt: 'Detalhes', en: 'Details' })"
        @onFilter="filterFor()"
        @onGoTo="(e) => goTo(e)"
        @onClearFilter="clearFilter()"
        @onToggleFilter="(e, type) => toggleFilter(e, type)"
        @onPaginate="paginate($event)"
      >
        <template #filters>
          <InputText v-if="filterType == 'userName'" v-model="filters.name" />
        </template>
      </Table>
    </div>
  </section>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GoToRoute } from "@/utils/go-to.util";
import { saveAs } from "file-saver";
import { debounceTime, delay } from "rxjs";
import { defineComponent } from "vue";
import { AttentionLogsService } from "./attentionLogs.service";
import { columns } from "./attentionLogs.utils";

export default defineComponent({
  name: "students",
  computed: {
    rest(): StatsRest {
      return new StatsRest();
    },
    service(): AttentionLogsService {
      return new AttentionLogsService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    classroomId(): string {
      return String(localStorage.getItem("stdClassroomId"));
    },
  },
  props: {
    courseId: {
      type: String,
      default: "",
    },
    studentId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      columns: columns as any,
      loading: true as boolean,
      btnLoading: false as boolean,
      items: [] as any,
      actions: [] as any,
      params: new QueryParams(),
      filters: {
        isCleareable: false,
        name: null,
      } as any,
      filterType: "" as string,
    };
  },
  mounted() {
    this.setPage();
  },
  methods: {
    goTo(user: any): void {
      this.go.redirectToPage("statsStudent", {
        studentId: user.userId,
        courseId: this.courseId,
        studentName: user.userName,
      });
    },
    paginate(event: { page: number; rows: number }): void {
      this.params.page = event.page;
      this.params.size = event.rows;
      this.setPage();
    },
    setPage(): void {
      this.loading = true;
      this.service.attentionLogs.pipe(debounceTime(500)).subscribe({
        next: (response: any) => {
          this.loading = false;
          this.items = response.content;
          this.params.total = response.total;
        },
      });
      this.service.getAllAttentionLogsByStudent(
        this.courseId,
        this.studentId,
        this.params
      );
    },

    toggleFilter(event: any, type: string): void {
      this.filterType = type;
    },
    filterFor(): void {
      this.filters.isCleareable = this.isCleareable();
      this.params.name = this.filters.name;
      if (this.filterType == "userName") {
        this.setPage();
      }
    },
    clearFilter(): void {
      this.filters.isCleareable = false;
      this.filters.name = null;
      this.setPage();
    },
    isCleareable(): boolean {
      return this.filters.name !== "";
    },
    downloadCSV(): void {
      this.btnLoading = true;
      this.rest
        .getLogsByCourseIdAndStudentIdDownload(this.courseId, this.studentId, {
          classroomId: this.classroomId ?? undefined,
        })
        .pipe(delay(1000))
        .subscribe({
          next: (response) => {
            this.btnLoading = false;
            const blob = new Blob([response], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            saveAs(url, `logs_attention_student.csv`);
          },
          error: () => {
            this.btnLoading = false;
          },
        });
    },
  },
});
</script>
